import { render } from "./AudienceDetail.vue?vue&type=template&id=5f824dda&scoped=true"
import script from "./AudienceDetail.vue?vue&type=script&lang=js"
export * from "./AudienceDetail.vue?vue&type=script&lang=js"

import "./AudienceDetail.vue?vue&type=style&index=0&id=5f824dda&scoped=true&lang=css"
import "./AudienceDetail.vue?vue&type=style&index=1&id=5f824dda&lang=scss"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f824dda"]])

export default __exports__